// CREATE TWO COLUMN TO SHOW COLLECTION IMAGE ONCOLLECTION SECOND LEVEL HOVER ELEMENT
const child_link_left = document.querySelectorAll(".site-nav__dropdown-link[data-attribute-coordinate='left']");
const child_link_right = document.querySelectorAll(".site-nav__dropdown-link[data-attribute-coordinate='right']");
const site_left = document.querySelector(".site-nav__dropdown-image-left");
const site_left_img = document.querySelectorAll(".site-nav__dropdown-image-left img");
const site_right = document.querySelector(".site-nav__dropdown-image-right");
const site_right_img = document.querySelectorAll(".site-nav__dropdown-image-right img");

let data_attribute_link;

child_link_left.forEach((item) => {
  item.addEventListener("mouseenter", () => {
    data_attribute_link = item.getAttribute("data-attribute-link");
    site_left.classList.add("active");

    const elem = document.querySelector('.site-nav__dropdown-image-left img[data-attribute-img="' + data_attribute_link + '"]');
    if (elem) {
      elem.classList.add("active");
    }
  });

  item.addEventListener("mouseout", () => {
    data_attribute_link = item.getAttribute("data-attribute-link");
    site_left.classList.remove("active");
    
    const elem = document.querySelector('.site-nav__dropdown-image-left img[data-attribute-img="' + data_attribute_link + '"]');
    if (elem) {
      elem.classList.remove("active");
    }
  });
});

child_link_right.forEach((item) => {
  item.addEventListener("mouseenter", () => {
    data_attribute_link = item.getAttribute("data-attribute-link");
    site_right.classList.add("active");

    const elem = document.querySelector('.site-nav__dropdown-image-right img[data-attribute-img="' + data_attribute_link + '"]');
    if (elem) {
      elem.classList.add("active");
    }
  });

  item.addEventListener("mouseout", () => {
    data_attribute_link = item.getAttribute("data-attribute-link");
    site_right.classList.remove("active");

    const elem = document.querySelector('.site-nav__dropdown-image-right img[data-attribute-img="' + data_attribute_link + '"]');
    if (elem) {
      elem.classList.remove("active");
    }
  });
});

// TRIGGER ANIMATION FOR MAIN COLLECTION ON MOBILE MENU
const collapsible_button = document.querySelectorAll("#NavDrawer .collapsible-trigger.collapsible--auto-height");

window.addEventListener("load", () => {
  ToggleClassCollapsibleTrigger();
});

function ToggleClassCollapsibleTrigger() {
  collapsible_button.forEach((item) => {
    if (item.classList.contains("is-open")) {
      item.closest(".mobile-nav__has-sublist").classList.add("active");
    } else {
      item.closest(".mobile-nav__has-sublist").classList.remove("active");
    }
  });
}
